import React, { useEffect, useState } from "react";
import { Loader2, Trash2, Rows } from "lucide-react";
import toast from "react-hot-toast";

import { getProposalSections, deleteProposalSection } from "../api/prospectingReportsApi";
import ProposalWorkspaceNav from "../components/ProposalWorkspaceNav";

/** Proply "Sections" — the library of reusable saved sections an agent can drop
 * into any proposal. Sections are saved from the builder; here they're managed. */
const ProposalSectionsPage = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    getProposalSections()
      .then(({ data }) => setSections(data?.results || []))
      .catch(() => toast.error("Could not load sections."))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (s) => {
    if (!window.confirm(`Delete the saved section "${s.name}"?`)) return;
    try { await deleteProposalSection(s.id); setSections((prev) => prev.filter((x) => x.id !== s.id)); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not delete it."); }
  };

  return (
    <div className="p-4 md:p-6 flex gap-6">
      <ProposalWorkspaceNav active="sections" onOpenNotifications={() => {}} />
      <div className="flex-1 min-w-0">
        <h1 className="text-2xl font-bold text-gray-900 mb-1 flex items-center gap-2"><Rows className="w-6 h-6" style={{ color: "#0f8d9b" }} /> Sections</h1>
        <p className="text-sm text-gray-500 mb-5">Reusable sections you can drop into any proposal. Save one from the builder's section menu.</p>
        {loading ? (
          <div className="flex items-center justify-center py-20 text-gray-400"><Loader2 className="w-6 h-6 animate-spin" /></div>
        ) : sections.length === 0 ? (
          <div className="border border-dashed border-gray-200 rounded-xl py-16 text-center text-sm text-gray-500">No saved sections yet.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {sections.map((s) => (
              <div key={s.id} className="bg-white border border-gray-100 rounded-xl p-4 flex items-start justify-between">
                <div className="min-w-0">
                  <p className="font-semibold text-gray-900 truncate">{s.name}</p>
                  <p className="text-xs text-gray-400 capitalize">{(s.block_type || "").replace(/_/g, " ")}</p>
                </div>
                {s.is_editable && (
                  <button onClick={() => remove(s)} className="p-1.5 rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-600" aria-label="Delete"><Trash2 className="w-4 h-4" /></button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProposalSectionsPage;
